const cleanLine = (value = "") => String(value || "").replace(/[\u200e\u200f]/g, "").trim();

const section = (title, lines = []) => {
  const safeLines = lines.map(cleanLine).filter(Boolean);
  if (!safeLines.length) return "";

  return `${cleanLine(title)}
${"-".repeat(cleanLine(title).length)}
${safeLines.join("\n")}
`;
};

const buildKeyValueLines = (items = []) =>
  items.map((item) => `${cleanLine(item.label)}: ${cleanLine(item.value)}`);

const buildNumericalRows = (numericalResults) => {
  if (!numericalResults?.rows?.length) return [];

  return numericalResults.rows.map((row) =>
    [
      cleanLine(row.item),
      cleanLine(row.metric),
      cleanLine(row.value),
      cleanLine(row.change),
    ]
      .filter(Boolean)
      .join(" | ")
  );
};

export const buildTextExport = ({ model, t }) => {
  const language = model.language;
  const locale = language === "en" ? "en-US" : "ar-SA";

  if (model.aiServiceFailure) {
    return `
${cleanLine(model.reportName)}
${"=".repeat(cleanLine(model.reportName).length)}
${cleanLine(t("reports.createdAt", language === "en" ? "Created At" : "تاريخ الإنشاء"))}: ${cleanLine(
      new Date(model.generatedAt).toLocaleString(locale)
    )}

${section(
  t("reports.aiAnalysisFailed", language === "en" ? "AI analysis failed" : "فشل التحليل الذكي"),
  [model.userFacingAiError]
)}
`.trim();
  }

  return `
${cleanLine(model.reportTitle)}
${"=".repeat(cleanLine(model.reportTitle).length)}
${cleanLine(t("reports.createdAt", language === "en" ? "Created At" : "تاريخ الإنشاء"))}: ${cleanLine(
      new Date(model.generatedAt).toLocaleString(locale)
    )}
${model.reportSubtitle ? `\n${cleanLine(model.reportSubtitle)}` : ""}
${model.reportDescription ? `\n${cleanLine(model.reportDescription)}` : ""}

${section(t("reports.reportMeta", language === "en" ? "Report Meta" : "بيانات التقرير"), buildKeyValueLines(model.reportMeta))}
${section(
  t("reports.basicReportData", language === "en" ? "Basic Report Data" : "بيانات التقرير الأساسية"),
  buildKeyValueLines(model.basicReportData)
)}
${section(
  t("reports.numericalResults", language === "en" ? "Numerical Results" : "نتائج رقمية"),
  [
    model.numericalResults?.description || "",
    ...buildNumericalRows(model.numericalResults),
  ]
)}
${section(t("reports.analysis", language === "en" ? "Analysis" : "التحليل"), model.analysis.map((item, index) => `${index + 1}. ${item}`))}
${section(
  t(
    "reports.recommendationsAndAlerts",
    language === "en" ? "Recommendations & Alerts" : "التوصيات والتنبيهات"
  ),
  model.recommendationsAndAlerts.map((item) => `- ${item}`)
)}
`.trim();
};
